export default () => {
    document.querySelector('#topOfPage').scrollIntoView({
        behavior: 'smooth'
    });
};
